import { render, staticRenderFns } from "./MitMyReservationsPage.vue?vue&type=template&id=700b4baa&scoped=true"
import script from "./MitMyReservationsPage.vue?vue&type=script&lang=js"
export * from "./MitMyReservationsPage.vue?vue&type=script&lang=js"
import style0 from "./MitMyReservationsPage.vue?vue&type=style&index=0&id=700b4baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b4baa",
  null
  
)

export default component.exports